import React, { useEffect, useState } from "react";
import { Button, Title } from "rbx";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_USERS} from "./graphql";
import { useModal, useAuth } from "../../context";
import { Loader } from "../../components";
import IncompleteFollowups from "./IncompleteFollowups";
import CompletedFollowups from "./CompletedFollowups";
import "./Followups.scss";
import FollowupFormModal from "./components/FollowupFormModal/FollowupFormModal";

const Followups = () => {
  const params = useParams();
  // id being employee number
  const { id } = params;

  // brings back all reviews where at least one authorEmployeeNumber matches their employee number
  const {
    data: userData,
    loading,
    refetch,
  } = useQuery(GET_USERS, {
    variables: {
      where: {
        employeeNumber: {contains: id}
      },
      fetchPolicy: "network-only",
    }
  });

  const { setModalOpen, isModalOpen } = useModal();
  const auth = useAuth();
  const activeUserEmployeeNumber = auth?.state?.user?.employeeNumber;
  
  const isUsersOwnFollowups =
    activeUserEmployeeNumber?.trim() === id?.trim();

  const [followups, setFollowups] = useState([]);
  const [isCompletedFollowups, setIsCompletedFollowups] = useState(false);

  useEffect(() => {
    if (userData?.users[0]?.followups) {
      setFollowups(userData?.users[0]?.followups);
    }
  }, [userData, id, refetch, isModalOpen]);

  useEffect(() => {
    refetch();
  }, [refetch, id]);

  const handleComplete = async () => {
    refetch();
    setModalOpen(false);
  };

  const handleOpenFollowupAdd = (followup, type) => {
    setModalOpen(
      true,
      <FollowupFormModal editFollowup={followup} type={type} userData={userData?.users[0]} onComplete={handleComplete}/>
    );
  };
  

  if (loading) {
    return (
      <div className="inner-container">
        <Loader />
      </div>
    );
  }

  if (!followups.length) {
    return (
      <div className="inner-container">
        <div className="reviews" style={{width:"70%", alignItems: "center"}}>
          {!isUsersOwnFollowups && (
            <div className="add-button-container">
              <Button
                className="review-option-primary"
                style={{ marginBottom: "1.5rem", padding: "0.5rem"}}
                type="button"
                onClick={() => handleOpenFollowupAdd()}
              >
                <Title size={6} textColor="white">
                  Add Follow-up
                </Title>
              </Button> 
            </div>
          )}
          <Title className="centerTitle" >No Follow-ups Found</Title>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="inner-container">
        <Button
          className={isCompletedFollowups ? "unselectedBtn" : "selectedBtn"}
          type="button"
          onClick={() => setIsCompletedFollowups(!isCompletedFollowups)}
        >
          <p>Active</p>
        </Button>
        <Button
          className={isCompletedFollowups ? "selectedBtn" : "unselectedBtn"}
          type="button"
          onClick={() => setIsCompletedFollowups(!isCompletedFollowups)}
        >
          <p>Completed</p>
        </Button>
     
      </div>
      {isCompletedFollowups ? (
        <CompletedFollowups
          employeeNumber={id}
          followups={followups}
          loading={loading}
          setFollowups={setFollowups}
          userData={userData?.users[0]}
        />
      ) : (
        <IncompleteFollowups
          employeeNumber={id}
          followups={followups}
          handleOpenFollowupAdd={handleOpenFollowupAdd}
          loading={loading}
          refetchMyFollowups={refetch}
          setFollowups={setFollowups}
          userData={userData?.users[0]}
        />
      )}
    </div>
  );
};

export default Followups; 